module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-144x144-ef2c56d77091abff6528f6b732724e4a.png";